import { c as o } from "./@contentful-cca97bae.js";
import { l as h } from "./domelementtype-4b6931b4.js";
import { l as b } from "./entities-09dd0ad3.js";
var u = {}, c = {};
Object.defineProperty(c, "__esModule", { value: !0 });
c.attributeNames = c.elementNames = void 0;
c.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(e) {
  return [e.toLowerCase(), e];
}));
c.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(e) {
  return [e.toLowerCase(), e];
}));
var f = o && o.__assign || function() {
  return f = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, f.apply(this, arguments);
}, M = o && o.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(t, n);
  (!a || ("get" in a ? !t.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, a);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), _ = o && o.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), x = o && o.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && M(t, e, n);
  return _(t, e), t;
};
Object.defineProperty(u, "__esModule", { value: !0 });
u.render = void 0;
var i = x(h), l = b, v = c, y = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function C(e) {
  return e.replace(/"/g, "&quot;");
}
function T(e, t) {
  var n;
  if (e) {
    var r = ((n = t.encodeEntities) !== null && n !== void 0 ? n : t.decodeEntities) === !1 ? C : t.xmlMode || t.encodeEntities !== "utf8" ? l.encodeXML : l.escapeAttribute;
    return Object.keys(e).map(function(a) {
      var d, m, g = (d = e[a]) !== null && d !== void 0 ? d : "";
      return t.xmlMode === "foreign" && (a = (m = v.attributeNames.get(a)) !== null && m !== void 0 ? m : a), !t.emptyAttrs && !t.xmlMode && g === "" ? a : "".concat(a, '="').concat(r(g), '"');
    }).join(" ");
  }
}
var p = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function s(e, t) {
  t === void 0 && (t = {});
  for (var n = ("length" in e) ? e : [e], r = "", a = 0; a < n.length; a++)
    r += O(n[a], t);
  return r;
}
u.render = s;
u.default = s;
function O(e, t) {
  switch (e.type) {
    case i.Root:
      return s(e.children, t);
    case i.Doctype:
    case i.Directive:
      return D(e);
    case i.Comment:
      return L(e);
    case i.CDATA:
      return S(e);
    case i.Script:
    case i.Style:
    case i.Tag:
      return A(e, t);
    case i.Text:
      return P(e, t);
  }
}
var j = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), w = /* @__PURE__ */ new Set(["svg", "math"]);
function A(e, t) {
  var n;
  t.xmlMode === "foreign" && (e.name = (n = v.elementNames.get(e.name)) !== null && n !== void 0 ? n : e.name, e.parent && j.has(e.parent.name) && (t = f(f({}, t), { xmlMode: !1 }))), !t.xmlMode && w.has(e.name) && (t = f(f({}, t), { xmlMode: "foreign" }));
  var r = "<".concat(e.name), a = T(e.attribs, t);
  return a && (r += " ".concat(a)), e.children.length === 0 && (t.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    t.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    t.selfClosingTags && p.has(e.name)
  )) ? (t.xmlMode || (r += " "), r += "/>") : (r += ">", e.children.length > 0 && (r += s(e.children, t)), (t.xmlMode || !p.has(e.name)) && (r += "</".concat(e.name, ">"))), r;
}
function D(e) {
  return "<".concat(e.data, ">");
}
function P(e, t) {
  var n, r = e.data || "";
  return ((n = t.encodeEntities) !== null && n !== void 0 ? n : t.decodeEntities) !== !1 && !(!t.xmlMode && e.parent && y.has(e.parent.name)) && (r = t.xmlMode || t.encodeEntities !== "utf8" ? (0, l.encodeXML)(r) : (0, l.escapeText)(r)), r;
}
function S(e) {
  return "<![CDATA[".concat(e.children[0].data, "]]>");
}
function L(e) {
  return "<!--".concat(e.data, "-->");
}
export {
  u as l
};
